module.exports = __webpack_public_path__ + "static/media/bt-favorito-normal.7bb1980c.svg";